<template>
  <div>
    <PrimaryButton text @click.native="openDialog">
      Share
      <template v-slot:prepend:icon>
        <v-icon color="primary" class="mr-2">
          mdi-account-group-outline
        </v-icon>
      </template>
    </PrimaryButton>
    <ShareBookingDialog v-if="isOpen" @close="close" />
  </div>
</template>

<script>
import ShareBookingDialog from "@/views/bookings/components/ConfirmDialogs/ShareBookingDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "ShareBookingAction",
  components: { PrimaryButton, ShareBookingDialog },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    }
  }
};
</script>
